module.exports = __webpack_public_path__ + "img/festival-calendar.9ce1809a.gif";